import { render } from "./mvt-header-menu-auth.vue?vue&type=template&id=6aebc744"
import script from "./mvt-header-menu-auth.vue?vue&type=script&lang=js"
export * from "./mvt-header-menu-auth.vue?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__